export enum AttributeMappingTableType {
  TO_MAP = 'TO_MAP',
  MAPPED = 'MAPPED',
  MAPPED_AS_EMPTY = 'MAPPED_AS_EMPTY',
  SOFT_DELETED = 'SOFT_DELETED',
}
